import { createSlice } from "@reduxjs/toolkit";
import {
  getSessionMessage,
  getSessionMessageV2,
} from "../actions/fluxoNSimilar";

interface MessageState {
  sessionMessage: any | null;
  status: "idle" | "loading" | "ready" | "error";
  error: unknown | null;
  httpStatus: number | null;
  messageStatus: any;
}

const initialState: MessageState = {
  sessionMessage: null,
  status: "idle",
  error: null,
  httpStatus: null,
  messageStatus: null,
};

const sessionMessageSlice = createSlice({
  name: "sessionMessage",
  initialState,
  reducers: {
    resetClear(state) {
      return initialState;
    },
    resetHttpStatus: (state) => {
      state.httpStatus = null;
    },
    resetMessage: (state) => {
      state.sessionMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSessionMessage.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getSessionMessage.rejected, (state, action) => {
        state.status = "error";
        state.sessionMessage = null;
        state.error = action.payload;
        state.httpStatus = action.payload?.httpStatus || null;
        state.messageStatus = action.error.message;
      })
      .addCase(getSessionMessage.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionMessage = action.payload;
        state.error = null;
        state.httpStatus = 200;
      })
      .addCase(getSessionMessageV2.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getSessionMessageV2.rejected, (state, action) => {
        state.status = "error";
        state.sessionMessage = null;
        state.error = action.payload;
        state.httpStatus = action.payload?.httpStatus || null;
        state.messageStatus = action.error.message;
      })
      .addCase(getSessionMessageV2.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionMessage = action.payload;
        state.error = null;
        state.httpStatus = 200;
      });
  },
});

export const { resetClear, resetHttpStatus, resetMessage } =
  sessionMessageSlice.actions;

export default sessionMessageSlice.reducer;
